import { useMemo, useState } from 'react';

function clamp(value, min, max) {
  return Math.min(max, Math.max(min, value));
}

function getWideTitleWidthPercent(ratio) {
  if (!Number.isFinite(ratio) || ratio <= 0) return 100;

  // More compact title marks can grow; very wide, low-height marks stay natural.
  return clamp(140 - ratio * 8, 100, 120);
}

export default function TitleImageOverlay({
  src,
  group,
  className = '',
  wideBottomClass = 'bottom-4',
  compactBottomClass = 'bottom-3',
}) {
  const [naturalRatio, setNaturalRatio] = useState(null);
  if (!src) return null;

  const isWideTitle = group?.titleImageLayout === 'wide' || group?.titleImageAspect === 'wide';
  const widthPercent = useMemo(
    () => (isWideTitle ? getWideTitleWidthPercent(naturalRatio) : null),
    [isWideTitle, naturalRatio]
  );

  return (
    <img
      src={src}
      alt="title"
      className={[
        'absolute left-1/2 -translate-x-1/2 h-auto pointer-events-none',
        className,
        isWideTitle ? `${wideBottomClass} max-w-none` : `${compactBottomClass} w-[70%] max-w-none`,
      ].join(' ')}
      style={isWideTitle ? { width: `${widthPercent}%` } : undefined}
      loading="lazy"
      decoding="async"
      draggable={false}
      onLoad={(event) => {
        const { naturalWidth, naturalHeight } = event.currentTarget;
        if (naturalWidth > 0 && naturalHeight > 0) {
          setNaturalRatio(naturalWidth / naturalHeight);
        }
      }}
    />
  );
}

export { getWideTitleWidthPercent };
